import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Result, Button } from 'antd';

interface Props {
  domain: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/**
 * Per-domain error boundary.
 *
 * Catches runtime errors inside a domain and renders a friendly fallback
 * instead of crashing the whole application.
 * Wrap each domain lazy-loaded component with this boundary in App/index.js.
 */
export class DomainErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[${this.props.domain}] Unhandled error:`, error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title={`Erro no módulo ${this.props.domain}`}
          subTitle={
            this.state.error?.message ??
            'Ocorreu um erro inesperado. Recarregue a página ou entre em contato com o suporte.'
          }
          extra={
            <Button type="primary" onClick={this.handleReset}>
              Tentar novamente
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default DomainErrorBoundary;
